import ArticleSearch from "Components/search/article/article";
import handleLoadMoreLabel from "Helpers/loadMore";

const Desktop = (props) => {

	const prop = props;
	const limitData = 12;

	return (
		<div className="component-tab-article">
			{
				prop.dataArticle?.data?.articles.length > 0 ? (
					<>

						<div className="component-tab-article__section-title">
							<p className="component-tab-article__title title-article">Articles</p>
						</div>
						<div className="component-tab-article__article">
							{
								prop.dataArticle?.data?.articles.map((data) => (
									<ArticleSearch
										key={data.id}
										isMobile={prop.isMobile}
										image={data.image}
										label={data.title}
										category={data.category[0]?.name}
										title={data.title}
										author={data.author.username}
										url={data.url}
										defaultPicture={prop.defaultPicture}
									/>

								))
							}
						</div>
						{
							prop.dataArticle?.data?.articles.length < prop.dataArticle?.pagination.total && (
								<div className="component-tab-article__section-more-data">
									<button
										type="button"
										className="component-tab-article__title-more-data"
										onClick={prop.handleLoadMoreArticle}
										id="id-loadmore"
									>
										{handleLoadMoreLabel({
											page: prop.dataArticle?.pagination.page,
											limit: limitData,
											total: prop.dataArticle?.pagination.total,
											data: prop.dataArticle?.data?.articles,
											text: "Articles",
										})}
									</button>
								</div>
							)
						}
					</>
				)
					: (
						<div className="component-tab-article__section-image-error">
							<img src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/error-image/image-no-result.png" alt="page error" className="component-tab-article__image-error" />
							<h4 className="component-tab-article__title">Sorry, no result found</h4>
							<p className="component-tab-article__sub_title">Please try another keyword!</p>
						</div>
					)
			}
			<style jsx>
				{`
						.component-tab-article{
							padding-top: 10px;
							max-width: 1280px;
							margin: auto;
						}
						.component-tab-article__section-title{
							display: flex;
							margin-top: 36px;
							margin-bottom: 22px;
							justify-content: space-between;
						}
						.component-tab-article__title{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							line-height: 24px;
							color: #13161A;
						}

						.component-tab-article__button-view-all{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 14px;
							line-height: 22px;
							color: #DB284E;
							background-color: transparent;
							border: none;
						}
						.component-tab-article__article{
							display: grid;
							grid-template-columns: repeat(3, calc(100%/3 - 22px));
							justify-items: stretch;
							justify-content: space-between;
							gap: 32px;

						}
						.component-tab-article__section-more-data{
							display: flex;
    						justify-content: center;
							margin-top: 24px;
						}
						.component-tab-article__title-more-data{
							font-family: 'Creato Display', sans-serif;
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							text-align: center;
							padding: 8px 16px;
							background: #fff;
							border: 1px solid #000;
							border-radius: 8px;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;
						}

						.component-tab-article__section-image-error{
							flex-direction: column;
							display: flex;
    						justify-content: center;
							align-items: center;
							padding: 45.5px 0 26px;
						}
						.component-tab-article__image-error{
							width: 200px;
							height: 200px;
							margin-bottom: 24px;

						}
						.component-tab-article__title{
							margin-bottom: 8px;
							font-family: 'Creato Display' !important;
						}
						.component-tab-article__sub_title{
							font-family: 'Creato Display' !important;
						}
					`}
			</style>
		</div>
	);

};

export default Desktop;
